<img [src]="path" alt="FLI-P logo" class="flip-logo" />
